module.exports = __webpack_public_path__ + "static/media/5.66b163fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/5.jpg
// module id = 68
// module chunks = 0